
















import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, DatePicker,
} from 'element-ui';
import Read from '@/servers/modules/read/read'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

    @Component({
      components: {
        Table,
        TableColumn,
        Button,
      },
    })
export default class extends Vue {
        @Mutation public setSkeletonDescribe;

        @Mutation public setNavData;

        @Getter public navData: any;

        @Getter public skeleton: any;

        @Getter public vteBasicData: any;

        private loading: boolean = true;

        private data: any;

        private startTime: any = '';

        private endTime: any = '';

        private pageNum: number = 1;

        private operat: string = '1';

        private tableHeaderClassName() {
          return 'table-header';
        }

        private tableRowClassName() {
          return 'table-row';
        }

        private tableData:any = [];

        private pickerOptions:any = [];

        private gameData:any = [];

        private async init() {
          /* 渲染时对应字段 枚举值
                nodeId 节点id
                processInstanceId 流程实例Id
            * */
          const res = await Read.queryCompetitionRecordVoList().catch((e:any) => {
            console.log(e);
          });
          if (!res.data.code && res.data.data.length > 0) {
            this.tableData = this.tableData.concat(res.data.data);
            console.log(this.tableData);
          }
        }

        private created() {
          // title
          this.title = '';// window.LS.get('vteData').course.courseTitle;
          this.pageNum;
          this.init();
        }
}
